import gql from 'graphql-tag';

export default gql`
  mutation removeManyLessonExerciseMutation($ids: [MongoID!]) {
    removeManyLessonExerciseMutation(ids: $ids) {
      message
      title
    }
  }
`;
